import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseContentCardMiniComponent } from '../base-content-card-mini.component';

@Component({
  selector: 'app-audio-card-mini',
  templateUrl: './audio-card-mini.component.html',
  styleUrls: ['./audio-card-mini.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioCardMiniComponent extends BaseContentCardMiniComponent {
  protected onChanged(viaQuery?: boolean): void {
    this.markForCheck();
  }
}
